<!-- validation errors -->
<p *ngIf="submitted && form[question.reference]?.errors" id="event-name-error" class="govuk-error-message">
  <!-- required -->
  <ng-container *ngIf="form[question.reference]?.errors?.required">
    <span class="govuk-visually-hidden">Error:</span>
    {{ 'COMMON.IS_REQUIRED' | translate : { value: question.name } }}
  </ng-container>
  <!-- pattern -->
  <ng-container *ngIf="form[question.reference]?.errors?.pattern">
    <span class="govuk-visually-hidden">Error:</span>
    {{ 'COMMON.INVALID' | translate : { value: question.name } }}
  </ng-container>
  <!-- email patttern -->
  <ng-container *ngIf="form[question.reference]?.errors?.email">
    <span class="govuk-visually-hidden">Error:</span>
    {{ 'COMMON.INVALID' | translate : { value: question.name } }}
  </ng-container>
  <!-- postcode patttern -->
  <ng-container *ngIf="form[question.reference]?.errors?.postcode">
    <span class="govuk-visually-hidden">Error:</span>
    {{ 'COMMON.INVALID_POSTCODE' | translate: { value: question.name } }}
  </ng-container>
  <!-- minlength -->
  <ng-container *ngIf="form[question.reference]?.errors?.minlength">
    <span class="govuk-visually-hidden">Error:</span>
    {{ 'COMMON.INVALID' | translate : { value: question.name } }}
  </ng-container>
  <!-- maxlength -->
  <ng-container *ngIf="form[question.reference]?.errors?.maxlength">
    <span class="govuk-visually-hidden">Error:</span>
    {{ 'COMMON.INVALID' | translate : { value: question.name } }}
  </ng-container>
  <!-- pastDate -->
  <ng-container *ngIf="form[question.reference]?.errors?.pastDate">
    <span class="govuk-visually-hidden">Error:</span>
    {{ 'COMMON.PAST_DATE' | translate : { value: question.name } }}
  </ng-container>
  <!-- older than one year -->
  <ng-container *ngIf="form[question.reference]?.errors?.olderThanOneYear">
    <span class="govuk-visually-hidden">Error:</span>
    {{ 'COMMON.TOO_OLD' | translate : { value: question.name } }}
  </ng-container>
  <!-- futureDate -->
  <ng-container *ngIf="form[question.reference]?.errors?.futureDate">
    <span class="govuk-visually-hidden">Error:</span>
    {{ 'COMMON.FUTURE_DATE' | translate : { value: question.name } }}
  </ng-container>

</p>

<!-- validation errors - before form submit -->
<p *ngIf="form[question.reference]?.errors" id="event-name-error" class="govuk-error-message">
    <ng-container *ngIf="form[question.reference]?.errors?.invalid_date">
    <span class="govuk-visually-hidden">Error:</span>
    {{ 'COMMON.INVALID_DATE' | translate : { value: question.name } }}
  </ng-container>
</p>